import { jsxs as me, Fragment as Be, jsx as k } from "react/jsx-runtime";
import { useField as Pe } from "formik";
import { memo as je, useRef as He, useEffect as G } from "react";
import Ue from "../Date/Input.js";
import { Label as We, ErrorLabel as Ke, HintLabel as qe } from "../Input/styled.js";
import { dateAdapter as Xe, dmyToYmd as Ge, ymdToDmy as Je } from "./helpers.js";
import { DatePickerOverrides as Ze, FieldWrapper as Qe, InputWrapper as Ve } from "./styled.js";
const T = {
  allRenderFn: !1,
  cmpDidLoad: !0,
  cmpDidUnload: !1,
  cmpDidUpdate: !0,
  cmpDidRender: !0,
  cmpWillLoad: !0,
  cmpWillUpdate: !0,
  cmpWillRender: !0,
  connectedCallback: !0,
  disconnectedCallback: !0,
  element: !0,
  event: !0,
  hasRenderFn: !0,
  lifecycle: !0,
  hostListener: !0,
  hostListenerTargetWindow: !0,
  hostListenerTargetDocument: !0,
  hostListenerTargetBody: !0,
  hostListenerTargetParent: !1,
  hostListenerTarget: !0,
  member: !0,
  method: !0,
  mode: !0,
  observeAttribute: !0,
  prop: !0,
  propMutable: !0,
  reflect: !0,
  scoped: !0,
  shadowDom: !0,
  slot: !0,
  cssAnnotations: !0,
  state: !0,
  style: !0,
  svg: !0,
  updatable: !0,
  vdomAttribute: !0,
  vdomXlink: !0,
  vdomClass: !0,
  vdomFunctional: !0,
  vdomKey: !0,
  vdomListener: !0,
  vdomRef: !0,
  vdomPropOrAttr: !0,
  vdomRender: !0,
  vdomStyle: !0,
  vdomText: !0,
  watchCallback: !0,
  taskQueue: !0,
  hotModuleReplacement: !1,
  isDebug: !1,
  isDev: !1,
  isTesting: !1,
  hydrateServerSide: !1,
  hydrateClientSide: !1,
  lifecycleDOMEvents: !1,
  lazyLoad: !1,
  profile: !1,
  slotRelocation: !0,
  appendChildSlotFix: !1,
  cloneNodeFix: !1,
  hydratedAttribute: !1,
  hydratedClass: !0,
  safari10: !1,
  scriptDataOpts: !1,
  scopedSlotTextContentFix: !1,
  shadowDomShim: !1,
  slotChildNodesFix: !1,
  invisiblePrehydration: !0,
  propBoolean: !0,
  propNumber: !0,
  propString: !0,
  cssVarShim: !1,
  constructableCSS: !0,
  cmpShouldUpdate: !0,
  devTools: !1,
  dynamicImportShim: !1,
  shadowDelegatesFocus: !0,
  initializeNextTick: !1,
  asyncLoading: !1,
  asyncQueue: !1,
  transformTagName: !1,
  attachStyles: !0
};
let F, ye, W, ve = !1, B = !1, V = !1, y = !1, se = null, J = !1;
const S = (e, t = "") => () => {
}, ae = "http://www.w3.org/1999/xlink", oe = {}, et = "http://www.w3.org/2000/svg", tt = "http://www.w3.org/1999/xhtml", st = (e) => e != null, ee = (e) => (e = typeof e, e === "object" || e === "function");
function at(e) {
  var t, s, a;
  return (a = (s = (t = e.head) === null || t === void 0 ? void 0 : t.querySelector('meta[name="csp-nonce"]')) === null || s === void 0 ? void 0 : s.getAttribute("content")) !== null && a !== void 0 ? a : void 0;
}
const d = (e, t, ...s) => {
  let a = null, o = null, i = null, n = !1, r = !1;
  const l = [], u = (c) => {
    for (let f = 0; f < c.length; f++)
      a = c[f], Array.isArray(a) ? u(a) : a != null && typeof a != "boolean" && ((n = typeof e != "function" && !ee(a)) && (a = String(a)), n && r ? l[l.length - 1].$text$ += a : l.push(n ? P(null, a) : a), r = n);
  };
  if (u(s), t) {
    t.key && (o = t.key), t.name && (i = t.name);
    {
      const c = t.className || t.class;
      c && (t.class = typeof c != "object" ? c : Object.keys(c).filter((f) => c[f]).join(" "));
    }
  }
  if (typeof e == "function")
    return e(t === null ? {} : t, l, it);
  const h = P(e, null);
  return h.$attrs$ = t, l.length > 0 && (h.$children$ = l), h.$key$ = o, h.$name$ = i, h;
}, P = (e, t) => {
  const s = {
    $flags$: 0,
    $tag$: e,
    $text$: t,
    $elm$: null,
    $children$: null
  };
  return s.$attrs$ = null, s.$key$ = null, s.$name$ = null, s;
}, be = {}, ot = (e) => e && e.$tag$ === be, it = {
  forEach: (e, t) => e.map(ie).forEach(t),
  map: (e, t) => e.map(ie).map(t).map(nt)
}, ie = (e) => ({
  vattrs: e.$attrs$,
  vchildren: e.$children$,
  vkey: e.$key$,
  vname: e.$name$,
  vtag: e.$tag$,
  vtext: e.$text$
}), nt = (e) => {
  if (typeof e.vtag == "function") {
    const s = Object.assign({}, e.vattrs);
    return e.vkey && (s.key = e.vkey), e.vname && (s.name = e.vname), d(e.vtag, s, ...e.vchildren || []);
  }
  const t = P(e.vtag, e.vtext);
  return t.$attrs$ = e.vattrs, t.$children$ = e.vchildren, t.$key$ = e.vkey, t.$name$ = e.vname, t;
}, rt = (e) => zt.map((t) => t(e)).find((t) => !!t), lt = (e, t) => e != null && !ee(e) ? t & 4 ? e === "false" ? !1 : e === "" || !!e : t & 2 ? parseFloat(e) : t & 1 ? String(e) : e : e, dt = (e) => e, E = (e, t, s) => {
  const a = dt(e);
  return {
    emit: (o) => ct(a, t, {
      bubbles: !!(s & 4),
      composed: !!(s & 2),
      cancelable: !!(s & 1),
      detail: o
    })
  };
}, ct = (e, t, s) => {
  const a = m.ce(t, s);
  return e.dispatchEvent(a), a;
}, ne = /* @__PURE__ */ new WeakMap(), ut = (e, t, s) => {
  let a = H.get(e);
  Ot && s ? (a = a || new CSSStyleSheet(), typeof a == "string" ? a = t : a.replaceSync(t)) : a = t, H.set(e, a);
}, ht = (e, t, s, a) => {
  var o;
  let i = _e(t, s);
  const n = H.get(i);
  if (e = e.nodeType === 11 ? e : _, n)
    if (typeof n == "string") {
      e = e.head || e;
      let r = ne.get(e), l;
      if (r || ne.set(e, r = /* @__PURE__ */ new Set()), !r.has(i)) {
        {
          l = _.createElement("style"), l.innerHTML = n;
          const u = (o = m.$nonce$) !== null && o !== void 0 ? o : at(_);
          u != null && l.setAttribute("nonce", u), e.insertBefore(l, e.querySelector("link"));
        }
        r && r.add(i);
      }
    } else e.adoptedStyleSheets.includes(n) || (e.adoptedStyleSheets = [...e.adoptedStyleSheets, n]);
  return i;
}, ft = (e) => {
  const t = e.$cmpMeta$, s = e.$hostElement$, a = t.$flags$, o = S("attachStyles", t.$tagName$), i = ht(s.shadowRoot ? s.shadowRoot : s.getRootNode(), t, e.$modeName$);
  a & 10 && (s["s-sc"] = i, s.classList.add(i + "-h"), a & 2 && s.classList.add(i + "-s")), o();
}, _e = (e, t) => "sc-" + (t && e.$flags$ & 32 ? e.$tagName$ + "-" + t : e.$tagName$), re = (e, t, s, a, o, i) => {
  if (s !== a) {
    let n = ue(e, t), r = t.toLowerCase();
    if (t === "class") {
      const l = e.classList, u = le(s), h = le(a);
      l.remove(...u.filter((c) => c && !h.includes(c))), l.add(...h.filter((c) => c && !u.includes(c)));
    } else if (t === "style") {
      for (const l in s)
        (!a || a[l] == null) && (l.includes("-") ? e.style.removeProperty(l) : e.style[l] = "");
      for (const l in a)
        (!s || a[l] !== s[l]) && (l.includes("-") ? e.style.setProperty(l, a[l]) : e.style[l] = a[l]);
    } else if (t !== "key")
      if (t === "ref")
        a && a(e);
      else if (!e.__lookupSetter__(t) && t[0] === "o" && t[1] === "n")
        t[2] === "-" ? t = t.slice(3) : ue(q, r) ? t = r.slice(2) : t = r[2] + t.slice(3), s && m.rel(e, t, s, !1), a && m.ael(e, t, a, !1);
      else {
        const l = ee(a);
        if ((n || l && a !== null) && !o)
          try {
            if (e.tagName.includes("-"))
              e[t] = a;
            else {
              const h = a ?? "";
              t === "list" ? n = !1 : (s == null || e[t] != h) && (e[t] = h);
            }
          } catch {
          }
        let u = !1;
        r !== (r = r.replace(/^xlink\:?/, "")) && (t = r, u = !0), a == null || a === !1 ? (a !== !1 || e.getAttribute(t) === "") && (u ? e.removeAttributeNS(ae, t) : e.removeAttribute(t)) : (!n || i & 4 || o) && !l && (a = a === !0 ? "" : a, u ? e.setAttributeNS(ae, t, a) : e.setAttribute(t, a));
      }
  }
}, pt = /\s/, le = (e) => e ? e.split(pt) : [], xe = (e, t, s, a) => {
  const o = t.$elm$.nodeType === 11 && t.$elm$.host ? t.$elm$.host : t.$elm$, i = e && e.$attrs$ || oe, n = t.$attrs$ || oe;
  for (a in i)
    a in n || re(o, a, i[a], void 0, s, t.$flags$);
  for (a in n)
    re(o, a, i[a], n[a], s, t.$flags$);
}, j = (e, t, s, a) => {
  const o = t.$children$[s];
  let i = 0, n, r, l;
  if (ve || (V = !0, o.$tag$ === "slot" && (F && a.classList.add(F + "-s"), o.$flags$ |= o.$children$ ? (
    // slot element has fallback content
    2
  ) : (
    // slot element does not have fallback content
    1
  ))), o.$text$ !== null)
    n = o.$elm$ = _.createTextNode(o.$text$);
  else if (o.$flags$ & 1)
    n = o.$elm$ = _.createTextNode("");
  else {
    if (y || (y = o.$tag$ === "svg"), n = o.$elm$ = _.createElementNS(y ? et : tt, o.$flags$ & 2 ? "slot-fb" : o.$tag$), y && o.$tag$ === "foreignObject" && (y = !1), xe(null, o, y), st(F) && n["s-si"] !== F && n.classList.add(n["s-si"] = F), o.$children$)
      for (i = 0; i < o.$children$.length; ++i)
        r = j(e, o, i, n), r && n.appendChild(r);
    o.$tag$ === "svg" ? y = !1 : n.tagName === "foreignObject" && (y = !0);
  }
  return n["s-hn"] = W, o.$flags$ & 3 && (n["s-sr"] = !0, n["s-cr"] = ye, n["s-sn"] = o.$name$ || "", l = e && e.$children$ && e.$children$[s], l && l.$tag$ === o.$tag$ && e.$elm$ && A(e.$elm$, !1)), n;
}, A = (e, t) => {
  m.$flags$ |= 1;
  const s = e.childNodes;
  for (let a = s.length - 1; a >= 0; a--) {
    const o = s[a];
    o["s-hn"] !== W && o["s-ol"] && (ke(o).insertBefore(o, te(o)), o["s-ol"].remove(), o["s-ol"] = void 0, V = !0), t && A(o, t);
  }
  m.$flags$ &= -2;
}, we = (e, t, s, a, o, i) => {
  let n = e["s-cr"] && e["s-cr"].parentNode || e, r;
  for (n.shadowRoot && n.tagName === W && (n = n.shadowRoot); o <= i; ++o)
    a[o] && (r = j(null, s, o, e), r && (a[o].$elm$ = r, n.insertBefore(r, te(t))));
}, De = (e, t, s, a, o) => {
  for (; t <= s; ++t)
    (a = e[t]) && (o = a.$elm$, Fe(a), B = !0, o["s-ol"] ? o["s-ol"].remove() : A(o, !0), o.remove());
}, $t = (e, t, s, a) => {
  let o = 0, i = 0, n = 0, r = 0, l = t.length - 1, u = t[0], h = t[l], c = a.length - 1, f = a[0], p = a[c], g, $;
  for (; o <= l && i <= c; )
    if (u == null)
      u = t[++o];
    else if (h == null)
      h = t[--l];
    else if (f == null)
      f = a[++i];
    else if (p == null)
      p = a[--c];
    else if (N(u, f))
      M(u, f), u = t[++o], f = a[++i];
    else if (N(h, p))
      M(h, p), h = t[--l], p = a[--c];
    else if (N(u, p))
      (u.$tag$ === "slot" || p.$tag$ === "slot") && A(u.$elm$.parentNode, !1), M(u, p), e.insertBefore(u.$elm$, h.$elm$.nextSibling), u = t[++o], p = a[--c];
    else if (N(h, f))
      (u.$tag$ === "slot" || p.$tag$ === "slot") && A(h.$elm$.parentNode, !1), M(h, f), e.insertBefore(h.$elm$, u.$elm$), h = t[--l], f = a[++i];
    else {
      for (n = -1, r = o; r <= l; ++r)
        if (t[r] && t[r].$key$ !== null && t[r].$key$ === f.$key$) {
          n = r;
          break;
        }
      n >= 0 ? ($ = t[n], $.$tag$ !== f.$tag$ ? g = j(t && t[i], s, n, e) : (M($, f), t[n] = void 0, g = $.$elm$), f = a[++i]) : (g = j(t && t[i], s, i, e), f = a[++i]), g && ke(u.$elm$).insertBefore(g, te(u.$elm$));
    }
  o > l ? we(e, a[c + 1] == null ? null : a[c + 1].$elm$, s, a, i, c) : i > c && De(t, o, l);
}, N = (e, t) => e.$tag$ === t.$tag$ ? e.$tag$ === "slot" ? e.$name$ === t.$name$ : e.$key$ === t.$key$ : !1, te = (e) => e && e["s-ol"] || e, ke = (e) => (e["s-ol"] ? e["s-ol"] : e).parentNode, M = (e, t) => {
  const s = t.$elm$ = e.$elm$, a = e.$children$, o = t.$children$, i = t.$tag$, n = t.$text$;
  let r;
  n === null ? (y = i === "svg" ? !0 : i === "foreignObject" ? !1 : y, i === "slot" || xe(e, t, y), a !== null && o !== null ? $t(s, a, t, o) : o !== null ? (e.$text$ !== null && (s.textContent = ""), we(s, null, t, o, 0, o.length - 1)) : a !== null && De(a, 0, a.length - 1), y && i === "svg" && (y = !1)) : (r = s["s-cr"]) ? r.parentNode.textContent = n : e.$text$ !== n && (s.data = n);
}, Se = (e) => {
  const t = e.childNodes;
  let s, a, o, i, n, r;
  for (a = 0, o = t.length; a < o; a++)
    if (s = t[a], s.nodeType === 1) {
      if (s["s-sr"]) {
        for (n = s["s-sn"], s.hidden = !1, i = 0; i < o; i++)
          if (r = t[i].nodeType, t[i]["s-hn"] !== s["s-hn"] || n !== "") {
            if (r === 1 && n === t[i].getAttribute("slot")) {
              s.hidden = !0;
              break;
            }
          } else if (r === 1 || r === 3 && t[i].textContent.trim() !== "") {
            s.hidden = !0;
            break;
          }
      }
      Se(s);
    }
}, b = [], Te = (e) => {
  let t, s, a, o, i, n, r = 0;
  const l = e.childNodes, u = l.length;
  for (; r < u; r++) {
    if (t = l[r], t["s-sr"] && (s = t["s-cr"]) && s.parentNode)
      for (a = s.parentNode.childNodes, o = t["s-sn"], n = a.length - 1; n >= 0; n--)
        s = a[n], !s["s-cn"] && !s["s-nr"] && s["s-hn"] !== t["s-hn"] && (de(s, o) ? (i = b.find((h) => h.$nodeToRelocate$ === s), B = !0, s["s-sn"] = s["s-sn"] || o, i ? i.$slotRefNode$ = t : b.push({
          $slotRefNode$: t,
          $nodeToRelocate$: s
        }), s["s-sr"] && b.map((h) => {
          de(h.$nodeToRelocate$, s["s-sn"]) && (i = b.find((c) => c.$nodeToRelocate$ === s), i && !h.$slotRefNode$ && (h.$slotRefNode$ = i.$slotRefNode$));
        })) : b.some((h) => h.$nodeToRelocate$ === s) || b.push({
          $nodeToRelocate$: s
        }));
    t.nodeType === 1 && Te(t);
  }
}, de = (e, t) => e.nodeType === 1 ? e.getAttribute("slot") === null && t === "" || e.getAttribute("slot") === t : e["s-sn"] === t ? !0 : t === "", Fe = (e) => {
  e.$attrs$ && e.$attrs$.ref && e.$attrs$.ref(null), e.$children$ && e.$children$.map(Fe);
}, gt = (e, t) => {
  const s = e.$hostElement$, a = e.$cmpMeta$, o = e.$vnode$ || P(null, null), i = ot(t) ? t : d(null, null, t);
  W = s.tagName, a.$attrsToReflect$ && (i.$attrs$ = i.$attrs$ || {}, a.$attrsToReflect$.map(([n, r]) => i.$attrs$[r] = s[n])), i.$tag$ = null, i.$flags$ |= 4, e.$vnode$ = i, i.$elm$ = o.$elm$ = s.shadowRoot || s, F = s["s-sc"], ye = s["s-cr"], ve = (a.$flags$ & 1) !== 0, B = !1, M(o, i);
  {
    if (m.$flags$ |= 1, V) {
      Te(i.$elm$);
      let n, r, l, u, h, c, f = 0;
      for (; f < b.length; f++)
        n = b[f], r = n.$nodeToRelocate$, r["s-ol"] || (l = _.createTextNode(""), l["s-nr"] = r, r.parentNode.insertBefore(r["s-ol"] = l, r));
      for (f = 0; f < b.length; f++)
        if (n = b[f], r = n.$nodeToRelocate$, n.$slotRefNode$) {
          for (u = n.$slotRefNode$.parentNode, h = n.$slotRefNode$.nextSibling, l = r["s-ol"]; l = l.previousSibling; )
            if (c = l["s-nr"], c && c["s-sn"] === r["s-sn"] && u === c.parentNode && (c = c.nextSibling, !c || !c["s-nr"])) {
              h = c;
              break;
            }
          (!h && u !== r.parentNode || r.nextSibling !== h) && r !== h && (!r["s-hn"] && r["s-ol"] && (r["s-hn"] = r["s-ol"].parentNode.nodeName), u.insertBefore(r, h));
        } else
          r.nodeType === 1 && (r.hidden = !0);
    }
    B && Se(i.$elm$), m.$flags$ &= -2, b.length = 0;
  }
}, mt = (e, t) => {
}, Me = (e, t) => (e.$flags$ |= 16, mt(e, e.$ancestorComponent$), Pt(() => yt(e, t))), yt = (e, t) => {
  const s = e.$hostElement$, a = S("scheduleUpdate", e.$cmpMeta$.$tagName$), o = s;
  let i;
  return t ? i = L(o, "componentWillLoad") : i = L(o, "componentWillUpdate"), i = ce(i, () => L(o, "componentWillRender")), a(), ce(i, () => vt(e, o, t));
}, vt = async (e, t, s) => {
  const a = e.$hostElement$, o = S("update", e.$cmpMeta$.$tagName$);
  a["s-rc"], s && ft(e);
  const i = S("render", e.$cmpMeta$.$tagName$);
  bt(e, t, a), i(), o(), _t(e);
}, bt = (e, t, s) => {
  try {
    se = t, t = t.render && t.render(), e.$flags$ &= -17, e.$flags$ |= 2, (T.hasRenderFn || T.reflect) && (T.vdomRender || T.reflect) && (T.hydrateServerSide || gt(e, t));
  } catch (r) {
    z(r, e.$hostElement$);
  }
  return se = null, null;
}, _t = (e) => {
  const t = e.$cmpMeta$.$tagName$, s = e.$hostElement$, a = S("postUpdate", t), o = s;
  e.$ancestorComponent$, L(o, "componentDidRender"), e.$flags$ & 64 ? (L(o, "componentDidUpdate"), a()) : (e.$flags$ |= 64, L(o, "componentDidLoad"), a());
}, L = (e, t, s) => {
  if (e && e[t])
    try {
      return e[t](s);
    } catch (a) {
      z(a);
    }
}, ce = (e, t) => e && e.then ? e.then(t) : t(), xt = (e, t) => K(e).$instanceValues$.get(t), wt = (e, t, s, a) => {
  const o = K(e), i = e, n = o.$instanceValues$.get(t), r = o.$flags$, l = i;
  s = lt(s, a.$members$[t][0]);
  const u = Number.isNaN(n) && Number.isNaN(s);
  if (s !== n && !u) {
    o.$instanceValues$.set(t, s);
    {
      if (a.$watchers$ && r & 128) {
        const c = a.$watchers$[t];
        c && c.map((f) => {
          try {
            l[f](s, n, t);
          } catch (p) {
            z(p, i);
          }
        });
      }
      if ((r & 18) === 2) {
        if (l.componentShouldUpdate && l.componentShouldUpdate(s, n, t) === !1)
          return;
        Me(o, !1);
      }
    }
  }
}, Dt = (e, t, s) => {
  if (t.$members$) {
    e.watchers && (t.$watchers$ = e.watchers);
    const a = Object.entries(t.$members$), o = e.prototype;
    a.map(([i, [n]]) => {
      (n & 31 || n & 32) && Object.defineProperty(o, i, {
        get() {
          return xt(this, i);
        },
        set(r) {
          wt(this, i, r, t);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const i = /* @__PURE__ */ new Map();
      o.attributeChangedCallback = function(n, r, l) {
        m.jmp(() => {
          const u = i.get(n);
          if (this.hasOwnProperty(u))
            l = this[u], delete this[u];
          else if (o.hasOwnProperty(u) && typeof this[u] == "number" && this[u] == l)
            return;
          this[u] = l === null && typeof this[u] == "boolean" ? !1 : l;
        });
      }, e.observedAttributes = a.filter(
        ([n, r]) => r[0] & 15
        /* MEMBER_FLAGS.HasAttribute */
      ).map(([n, r]) => {
        const l = r[1] || n;
        return i.set(l, n), r[0] & 512 && t.$attrsToReflect$.push([n, l]), l;
      });
    }
  }
  return e;
}, kt = async (e, t, s, a, o) => {
  if (!(t.$flags$ & 32) && (o = e.constructor, t.$flags$ |= 32, customElements.whenDefined(s.$tagName$).then(() => t.$flags$ |= 128), o.style)) {
    let n = o.style;
    typeof n != "string" && (n = n[t.$modeName$ = rt(e)]);
    const r = _e(s, t.$modeName$);
    if (!H.has(r)) {
      const l = S("registerStyles", s.$tagName$);
      ut(r, n, !!(s.$flags$ & 1)), l();
    }
  }
  t.$ancestorComponent$, Me(t, !0);
}, St = (e) => {
}, Tt = (e) => {
  if (!(m.$flags$ & 1)) {
    const t = K(e), s = t.$cmpMeta$, a = S("connectedCallback", s.$tagName$);
    t.$flags$ & 1 ? (Le(e, t, s.$listeners$), St(t.$lazyInstance$)) : (t.$flags$ |= 1, s.$flags$ & 12 && Ft(e), s.$members$ && Object.entries(s.$members$).map(([o, [i]]) => {
      if (i & 31 && e.hasOwnProperty(o)) {
        const n = e[o];
        delete e[o], e[o] = n;
      }
    }), kt(e, t, s)), a();
  }
}, Ft = (e) => {
  const t = e["s-cr"] = _.createComment("");
  t["s-cn"] = !0, e.insertBefore(t, e.firstChild);
}, Mt = (e) => {
  if (!(m.$flags$ & 1)) {
    const t = K(e);
    t.$rmListeners$ && (t.$rmListeners$.map((s) => s()), t.$rmListeners$ = void 0);
  }
}, Lt = (e, t) => {
  const s = {
    $flags$: t[0],
    $tagName$: t[1]
  };
  s.$members$ = t[2], s.$listeners$ = t[3], s.$watchers$ = e.$watchers$, s.$attrsToReflect$ = [];
  const a = e.prototype.connectedCallback, o = e.prototype.disconnectedCallback;
  return Object.assign(e.prototype, {
    __registerHost() {
      At(this, s);
    },
    connectedCallback() {
      Tt(this), a && a.call(this);
    },
    disconnectedCallback() {
      Mt(this), o && o.call(this);
    },
    __attachShadow() {
      this.attachShadow({
        mode: "open",
        delegatesFocus: !!(s.$flags$ & 16)
      });
    }
  }), e.is = s.$tagName$, Dt(e, s);
}, Le = (e, t, s, a) => {
  s && s.map(([o, i, n]) => {
    const r = Et(e, o), l = Ct(t, n), u = It(o);
    m.ael(r, i, l, u), (t.$rmListeners$ = t.$rmListeners$ || []).push(() => m.rel(r, i, l, u));
  });
}, Ct = (e, t) => (s) => {
  try {
    T.lazyLoad || e.$hostElement$[t](s);
  } catch (a) {
    z(a);
  }
}, Et = (e, t) => t & 4 ? _ : t & 8 ? q : t & 16 ? _.body : e, It = (e) => Nt ? {
  passive: (e & 1) !== 0,
  capture: (e & 2) !== 0
} : (e & 2) !== 0, Ce = /* @__PURE__ */ new WeakMap(), K = (e) => Ce.get(e), At = (e, t) => {
  const s = {
    $flags$: 0,
    $hostElement$: e,
    $cmpMeta$: t,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return Le(e, s, t.$listeners$), Ce.set(e, s);
}, ue = (e, t) => t in e, z = (e, t) => (0, console.error)(e, t), H = /* @__PURE__ */ new Map(), zt = [], q = typeof window < "u" ? window : {}, _ = q.document || { head: {} };
q.HTMLElement;
const m = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (e) => e(),
  raf: (e) => requestAnimationFrame(e),
  ael: (e, t, s, a) => e.addEventListener(t, s, a),
  rel: (e, t, s, a) => e.removeEventListener(t, s, a),
  ce: (e, t) => new CustomEvent(e, t)
}, Nt = /* @__PURE__ */ (() => {
  let e = !1;
  try {
    _.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        e = !0;
      }
    }));
  } catch {
  }
  return e;
})(), Yt = (e) => Promise.resolve(e), Ot = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), he = [], Ee = [], Rt = (e, t) => (s) => {
  e.push(s), J || (J = !0, t && m.$flags$ & 4 ? Bt(Z) : m.raf(Z));
}, fe = (e) => {
  for (let t = 0; t < e.length; t++)
    try {
      e[t](performance.now());
    } catch (s) {
      z(s);
    }
  e.length = 0;
}, Z = () => {
  fe(he), fe(Ee), (J = he.length > 0) && m.raf(Z);
}, Bt = (e) => Yt().then(e), Pt = /* @__PURE__ */ Rt(Ee, !0), jt = /^(\d{4})-(\d{2})-(\d{2})$/;
var C;
(function(e) {
  e[e.Sunday = 0] = "Sunday", e[e.Monday = 1] = "Monday", e[e.Tuesday = 2] = "Tuesday", e[e.Wednesday = 3] = "Wednesday", e[e.Thursday = 4] = "Thursday", e[e.Friday = 5] = "Friday", e[e.Saturday = 6] = "Saturday";
})(C || (C = {}));
function Ie(e, t, s) {
  var a = parseInt(s, 10), o = parseInt(t, 10), i = parseInt(e, 10);
  if (Number.isInteger(i) && // all parts should be integers
  Number.isInteger(o) && Number.isInteger(a) && o > 0 && // month must be 1-12
  o <= 12 && a > 0 && // day must be 1-31
  a <= 31 && i > 0)
    return new Date(i, o - 1, a);
}
function w(e) {
  if (!e)
    return;
  const t = e.match(jt);
  if (t)
    return Ie(t[1], t[2], t[3]);
}
function Ae(e) {
  if (!e)
    return "";
  var t = e.getDate().toString(10), s = (e.getMonth() + 1).toString(10), a = e.getFullYear().toString(10);
  return e.getDate() < 10 && (t = `0${t}`), e.getMonth() < 9 && (s = `0${s}`), `${a}-${s}-${t}`;
}
function U(e, t) {
  return e == null || t == null ? !1 : ze(e, t) && e.getDate() === t.getDate();
}
function ze(e, t) {
  return e == null || t == null ? !1 : e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth();
}
function Ne(e, t) {
  var s = new Date(e);
  return s.setDate(s.getDate() + t), s;
}
function Ye(e, t = C.Monday) {
  var s = new Date(e), a = s.getDay(), o = (a < t ? 7 : 0) + a - t;
  return s.setDate(s.getDate() - o), s;
}
function Oe(e, t = C.Monday) {
  var s = new Date(e), a = s.getDay(), o = (a < t ? -7 : 0) + 6 - (a - t);
  return s.setDate(s.getDate() + o), s;
}
function Y(e) {
  return new Date(e.getFullYear(), e.getMonth(), 1);
}
function O(e) {
  return new Date(e.getFullYear(), e.getMonth() + 1, 0);
}
function pe(e, t) {
  const s = new Date(e);
  return s.setMonth(t), s;
}
function $e(e, t) {
  const s = new Date(e);
  return s.setFullYear(t), s;
}
function Q(e, t, s) {
  return R(e, t, s) === e;
}
function R(e, t, s) {
  const a = e.getTime();
  return t && t instanceof Date && a < t.getTime() ? t : s && s instanceof Date && a > s.getTime() ? s : e;
}
function Ht(e, t) {
  const s = [];
  let a = e;
  for (; !U(a, t); )
    s.push(a), a = Ne(a, 1);
  return s.push(a), s;
}
function Ut(e, t = C.Monday) {
  const s = Ye(Y(e), t), a = Oe(O(e), t);
  return Ht(s, a);
}
function D() {
  return Math.random().toString(16).slice(-4);
}
function X(e) {
  return `${e}-${D()}${D()}-${D()}-${D()}-${D()}-${D()}${D()}${D()}`;
}
const Wt = ({ onClick: e, dateFormatter: t, localization: s, name: a, formattedValue: o, valueAsDate: i, value: n, identifier: r, disabled: l, required: u, role: h, buttonRef: c, inputRef: f, onInput: p, onBlur: g, onFocus: $ }) => d(
  "div",
  { class: "duet-date__input-wrapper" },
  d("input", { class: "duet-date__input", value: o, placeholder: s.placeholder, id: r, disabled: l, role: h, required: u ? !0 : void 0, "aria-autocomplete": "none", onInput: p, onFocus: $, onBlur: g, autoComplete: "off", ref: f }),
  d("input", { type: "hidden", name: a, value: n }),
  d(
    "button",
    { class: "duet-date__toggle", onClick: e, disabled: l, ref: c, type: "button" },
    d(
      "span",
      { class: "duet-date__toggle-icon" },
      d(
        "svg",
        { "aria-hidden": "true", height: "24", viewBox: "0 0 21 21", width: "24", xmlns: "http://www.w3.org/2000/svg" },
        d(
          "g",
          { fill: "none", "fill-rule": "evenodd", transform: "translate(2 2)" },
          d("path", { d: "m2.5.5h12c1.1045695 0 2 .8954305 2 2v12c0 1.1045695-.8954305 2-2 2h-12c-1.1045695 0-2-.8954305-2-2v-12c0-1.1045695.8954305-2 2-2z", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round" }),
          d("path", { d: "m.5 4.5h16", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round" }),
          d(
            "g",
            { fill: "currentColor" },
            d("circle", { cx: "8.5", cy: "8.5", r: "1" }),
            d("circle", { cx: "4.5", cy: "8.5", r: "1" }),
            d("circle", { cx: "12.5", cy: "8.5", r: "1" }),
            d("circle", { cx: "8.5", cy: "12.5", r: "1" }),
            d("circle", { cx: "4.5", cy: "12.5", r: "1" }),
            d("circle", { cx: "12.5", cy: "12.5", r: "1" })
          )
        )
      )
    ),
    d(
      "span",
      { class: "duet-date__vhidden" },
      s.buttonLabel,
      i && d(
        "span",
        null,
        ", ",
        s.selectedDateMessage,
        " ",
        t.format(i)
      )
    )
  )
), Kt = ({ focusedDay: e, today: t, day: s, onDaySelect: a, onKeyboardNavigation: o, focusedDayRef: i, disabled: n, inRange: r, isSelected: l, dateFormatter: u }) => {
  const h = U(s, t), c = ze(s, e), f = U(s, e), p = !r;
  function g($) {
    a($, s);
  }
  return d(
    "button",
    { class: {
      "duet-date__day": !0,
      "is-outside": p,
      "is-today": h,
      "is-month": c,
      "is-disabled": n
    }, tabIndex: f ? 0 : -1, onClick: g, onKeyDown: o, "aria-disabled": n ? "true" : void 0, disabled: p, type: "button", "aria-pressed": l ? "true" : "false", ref: ($) => {
      f && $ && i && i($);
    } },
    d("span", { "aria-hidden": "true" }, s.getDate()),
    d("span", { class: "duet-date__vhidden" }, u.format(s))
  );
};
function qt(e, t) {
  const s = [];
  for (let a = 0; a < e.length; a += t)
    s.push(e.slice(a, a + t));
  return s;
}
function Xt(e, t, s) {
  return e.map((a, o) => {
    const i = (o + t) % e.length;
    return s(e[i]);
  });
}
const Gt = ({ selectedDate: e, focusedDate: t, labelledById: s, localization: a, firstDayOfWeek: o, min: i, max: n, dateFormatter: r, isDateDisabled: l, onDateSelect: u, onKeyboardNavigation: h, focusedDayRef: c }) => {
  const f = /* @__PURE__ */ new Date(), p = Ut(t, o);
  return d(
    "table",
    { class: "duet-date__table", "aria-labelledby": s },
    d(
      "thead",
      null,
      d("tr", null, Xt(a.dayNames, o, (g) => d(
        "th",
        { class: "duet-date__table-header", scope: "col" },
        d("span", { "aria-hidden": "true" }, g.substr(0, 2)),
        d("span", { class: "duet-date__vhidden" }, g)
      )))
    ),
    d("tbody", null, qt(p, 7).map((g) => d("tr", { class: "duet-date__row" }, g.map(($) => d(
      "td",
      { class: "duet-date__cell" },
      d(Kt, { day: $, today: f, focusedDay: t, isSelected: U($, e), disabled: l($), inRange: Q($, i, n), onDaySelect: u, dateFormatter: r, onKeyboardNavigation: h, focusedDayRef: c })
    )))))
  );
}, Jt = {
  buttonLabel: "Choose date",
  placeholder: "YYYY-MM-DD",
  selectedDateMessage: "Selected date is",
  prevMonthLabel: "Previous month",
  nextMonthLabel: "Next month",
  monthSelectLabel: "Month",
  yearSelectLabel: "Year",
  closeLabel: "Close window",
  calendarHeading: "Choose a date",
  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  locale: "en-GB"
}, Zt = { parse: w, format: Ae }, Qt = '.duet-date *,.duet-date *::before,.duet-date *::after{box-sizing:border-box;margin:0;width:auto}.duet-date{box-sizing:border-box;color:var(--duet-color-text);display:block;font-family:var(--duet-font);margin:0;position:relative;text-align:left;width:100%}.duet-date__input{-webkit-appearance:none;appearance:none;background:var(--duet-color-surface);border:1px solid var(--duet-color-border, var(--duet-color-text));border-radius:var(--duet-radius);color:var(--duet-color-text);float:none;font-family:var(--duet-font);font-size:100%;line-height:normal;padding:14px 60px 14px 14px;width:100%}.duet-date__input:focus{border-color:var(--duet-color-primary);box-shadow:0 0 0 1px var(--duet-color-primary);outline:0}.duet-date__input::-webkit-input-placeholder{color:var(--duet-color-placeholder);opacity:1}.duet-date__input:-moz-placeholder{color:var(--duet-color-placeholder);opacity:1}.duet-date__input:-ms-input-placeholder{color:var(--duet-color-placeholder)}.duet-date__input-wrapper{position:relative;width:100%}.duet-date__toggle{-moz-appearance:none;-webkit-appearance:none;-webkit-user-select:none;align-items:center;appearance:none;background:var(--duet-color-button);border:0;border-radius:0;border-bottom-right-radius:var(--duet-radius);border-top-right-radius:var(--duet-radius);box-shadow:inset 1px 0 0 rgba(0, 0, 0, 0.1);color:var(--duet-color-text);cursor:pointer;display:flex;height:calc(100% - 2px);justify-content:center;padding:0;position:absolute;right:1px;top:1px;user-select:none;width:48px;z-index:2}.duet-date__toggle:focus{box-shadow:0 0 0 2px var(--duet-color-primary);outline:0}.duet-date__toggle-icon{display:flex;flex-basis:100%;justify-content:center;align-items:center}.duet-date__dialog{display:flex;left:0;min-width:320px;opacity:0;position:absolute;top:100%;transform:scale(0.96) translateZ(0) translateY(-20px);transform-origin:top right;transition:transform 300ms ease, opacity 300ms ease, visibility 300ms ease;visibility:hidden;width:100%;will-change:transform, opacity, visibility;z-index:var(--duet-z-index)}@media (max-width: 35.9375em){.duet-date__dialog{background:var(--duet-color-overlay);bottom:0;position:fixed;right:0;top:0;transform:translateZ(0);transform-origin:bottom center}}.duet-date__dialog.is-left{left:auto;right:0;width:auto}.duet-date__dialog.is-active{opacity:1;transform:scale(1.0001) translateZ(0) translateY(0);visibility:visible}.duet-date__dialog-content{background:var(--duet-color-surface);border:1px solid rgba(0, 0, 0, 0.1);border-radius:var(--duet-radius);box-shadow:0 4px 10px 0 rgba(0, 0, 0, 0.1);margin-left:auto;margin-top:8px;max-width:310px;min-width:290px;padding:16px 16px 20px;position:relative;transform:none;width:100%;z-index:var(--duet-z-index)}@media (max-width: 35.9375em){.duet-date__dialog-content{border:0;border-radius:0;border-top-left-radius:var(--duet-radius);border-top-right-radius:var(--duet-radius);bottom:0;left:0;margin:0;max-width:none;min-height:26em;opacity:0;padding:0 8% 20px;position:absolute;transform:translateZ(0) translateY(100%);transition:transform 400ms ease, opacity 400ms ease, visibility 400ms ease;visibility:hidden;will-change:transform, opacity, visibility}.is-active .duet-date__dialog-content{opacity:1;transform:translateZ(0) translateY(0);visibility:visible}}.duet-date__table{border-collapse:collapse;border-spacing:0;color:var(--duet-color-text);font-size:1rem;font-weight:var(--duet-font-normal);line-height:1.25;text-align:center;width:100%}.duet-date__table-header{font-size:0.75rem;font-weight:var(--duet-font-bold);letter-spacing:1px;line-height:1.25;padding-bottom:8px;text-decoration:none;text-transform:uppercase}.duet-date__cell{text-align:center}.duet-date__day{-moz-appearance:none;-webkit-appearance:none;appearance:none;background:transparent;border:0;border-radius:50%;color:var(--duet-color-text);cursor:pointer;display:inline-block;font-family:var(--duet-font);font-size:0.875rem;font-variant-numeric:tabular-nums;font-weight:var(--duet-font-normal);height:36px;line-height:1.25;padding:0 0 1px;position:relative;text-align:center;vertical-align:middle;width:36px;z-index:1}.duet-date__day.is-today{box-shadow:0 0 0 1px var(--duet-color-primary);position:relative;z-index:200}.duet-date__day:hover::before,.duet-date__day.is-today::before{background:var(--duet-color-primary);border-radius:50%;bottom:0;content:"";left:0;opacity:0.06;position:absolute;right:0;top:0}.duet-date__day[aria-pressed=true],.duet-date__day:focus{background:var(--duet-color-primary);box-shadow:none;color:var(--duet-color-text-active);outline:0}.duet-date__day:active{background:var(--duet-color-primary);box-shadow:0 0 5px var(--duet-color-primary);color:var(--duet-color-text-active);z-index:200}.duet-date__day:focus{box-shadow:0 0 5px var(--duet-color-primary);z-index:200}.duet-date__day:not(.is-month){box-shadow:none}.duet-date__day:not(.is-month),.duet-date__day[aria-disabled=true]{background:transparent;color:var(--duet-color-text);cursor:default;opacity:0.5}.duet-date__day[aria-disabled=true].is-today{box-shadow:0 0 0 1px var(--duet-color-primary)}.duet-date__day[aria-disabled=true].is-today:focus{box-shadow:0 0 5px var(--duet-color-primary);background:var(--duet-color-primary);color:var(--duet-color-text-active)}.duet-date__day[aria-disabled=true]:not(.is-today)::before{display:none}.duet-date__day.is-outside{background:var(--duet-color-button);box-shadow:none;color:var(--duet-color-text);cursor:default;opacity:0.6;pointer-events:none}.duet-date__day.is-outside::before{display:none}.duet-date__header{align-items:center;display:flex;justify-content:space-between;margin-bottom:16px;width:100%}.duet-date__nav{white-space:nowrap}.duet-date__prev,.duet-date__next{-moz-appearance:none;-webkit-appearance:none;align-items:center;appearance:none;background:var(--duet-color-button);border:0;border-radius:50%;color:var(--duet-color-text);cursor:pointer;display:inline-flex;height:32px;justify-content:center;margin-left:8px;padding:0;transition:background-color 300ms ease;width:32px}@media (max-width: 35.9375em){.duet-date__prev,.duet-date__next{height:40px;width:40px}}.duet-date__prev:focus,.duet-date__next:focus{box-shadow:0 0 0 2px var(--duet-color-primary);outline:0}.duet-date__prev:active:focus,.duet-date__next:active:focus{box-shadow:none}.duet-date__prev:disabled,.duet-date__next:disabled{cursor:default;opacity:0.5}.duet-date__prev svg,.duet-date__next svg{margin:0 auto}.duet-date__select{display:inline-flex;margin-top:4px;position:relative}.duet-date__select span{margin-right:4px}.duet-date__select select{cursor:pointer;font-size:1rem;height:100%;left:0;opacity:0;position:absolute;top:0;width:100%;z-index:2}.duet-date__select select:focus+.duet-date__select-label{box-shadow:0 0 0 2px var(--duet-color-primary)}.duet-date__select-label{align-items:center;border-radius:var(--duet-radius);color:var(--duet-color-text);display:flex;font-size:1.25rem;font-weight:var(--duet-font-bold);line-height:1.25;padding:0 4px 0 8px;pointer-events:none;position:relative;width:100%;z-index:1}.duet-date__select-label svg{width:16px;height:16px}.duet-date__mobile{align-items:center;border-bottom:1px solid rgba(0, 0, 0, 0.12);display:flex;justify-content:space-between;margin-bottom:20px;margin-left:-10%;overflow:hidden;padding:12px 20px;position:relative;text-overflow:ellipsis;white-space:nowrap;width:120%}@media (min-width: 36em){.duet-date__mobile{border:0;margin:0;overflow:visible;padding:0;position:absolute;right:-8px;top:-8px;width:auto}}.duet-date__mobile-heading{display:inline-block;font-weight:var(--duet-font-bold);max-width:84%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media (min-width: 36em){.duet-date__mobile-heading{display:none}}.duet-date__close{-webkit-appearance:none;align-items:center;appearance:none;background:var(--duet-color-button);border:0;border-radius:50%;color:var(--duet-color-text);cursor:pointer;display:flex;height:24px;justify-content:center;padding:0;width:24px}@media (min-width: 36em){.duet-date__close{opacity:0}}.duet-date__close:focus{box-shadow:0 0 0 2px var(--duet-color-primary);outline:none}@media (min-width: 36em){.duet-date__close:focus{opacity:1}}.duet-date__close svg{margin:0 auto}.duet-date__vhidden{border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;padding:0;position:absolute;top:0;width:1px}';
function Vt(e, t) {
  for (var s = [], a = e; a <= t; a++)
    s.push(a);
  return s;
}
const v = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
function es(e, t) {
  const s = e.value, a = e.selectionStart, o = s.slice(0, a), i = s.slice(a, s.length), n = o.replace(t, ""), r = i.replace(t, ""), l = n + r, u = n.length;
  return e.value = l, e.selectionStart = e.selectionEnd = u, l;
}
const ts = /[^0-9\.\/\-]+/g, ge = 300, ss = class extends HTMLElement {
  constructor() {
    super(), this.__registerHost(), this.duetChange = E(this, "duetChange", 7), this.duetBlur = E(this, "duetBlur", 7), this.duetFocus = E(this, "duetFocus", 7), this.duetOpen = E(this, "duetOpen", 7), this.duetClose = E(this, "duetClose", 7), this.monthSelectId = X("DuetDateMonth"), this.yearSelectId = X("DuetDateYear"), this.dialogLabelId = X("DuetDateLabel"), this.initialTouchX = null, this.initialTouchY = null, this.activeFocus = !1, this.focusedDay = /* @__PURE__ */ new Date(), this.open = !1, this.name = "date", this.identifier = "", this.disabled = !1, this.direction = "right", this.required = !1, this.value = "", this.min = "", this.max = "", this.firstDayOfWeek = C.Monday, this.localization = Jt, this.dateAdapter = Zt, this.isDateDisabled = () => !1, this.enableActiveFocus = () => {
      this.activeFocus = !0;
    }, this.disableActiveFocus = () => {
      this.activeFocus = !1;
    }, this.toggleOpen = (e) => {
      e.preventDefault(), this.open ? this.hide(!1) : this.show();
    }, this.handleEscKey = (e) => {
      e.keyCode === v.ESC && this.hide();
    }, this.handleBlur = (e) => {
      e.stopPropagation(), this.duetBlur.emit({
        component: "duet-date-picker"
      });
    }, this.handleFocus = (e) => {
      e.stopPropagation(), this.duetFocus.emit({
        component: "duet-date-picker"
      });
    }, this.handleTouchStart = (e) => {
      const t = e.changedTouches[0];
      this.initialTouchX = t.pageX, this.initialTouchY = t.pageY;
    }, this.handleTouchMove = (e) => {
      e.preventDefault();
    }, this.handleTouchEnd = (e) => {
      const t = e.changedTouches[0], s = t.pageX - this.initialTouchX, a = t.pageY - this.initialTouchY, o = 70, i = Math.abs(s) >= o && Math.abs(a) <= o, n = Math.abs(a) >= o && Math.abs(s) <= o && a > 0;
      i ? this.addMonths(s < 0 ? 1 : -1) : n && (this.hide(!1), e.preventDefault()), this.initialTouchY = null, this.initialTouchX = null;
    }, this.handleNextMonthClick = (e) => {
      e.preventDefault(), this.addMonths(1);
    }, this.handlePreviousMonthClick = (e) => {
      e.preventDefault(), this.addMonths(-1);
    }, this.handleFirstFocusableKeydown = (e) => {
      e.keyCode === v.TAB && e.shiftKey && (this.focusedDayNode.focus(), e.preventDefault());
    }, this.handleKeyboardNavigation = (e) => {
      if (e.keyCode === v.TAB && !e.shiftKey) {
        e.preventDefault(), this.firstFocusableElement.focus();
        return;
      }
      var t = !0;
      switch (e.keyCode) {
        case v.RIGHT:
          this.addDays(1);
          break;
        case v.LEFT:
          this.addDays(-1);
          break;
        case v.DOWN:
          this.addDays(7);
          break;
        case v.UP:
          this.addDays(-7);
          break;
        case v.PAGE_UP:
          e.shiftKey ? this.addYears(-1) : this.addMonths(-1);
          break;
        case v.PAGE_DOWN:
          e.shiftKey ? this.addYears(1) : this.addMonths(1);
          break;
        case v.HOME:
          this.startOfWeek();
          break;
        case v.END:
          this.endOfWeek();
          break;
        default:
          t = !1;
      }
      t && (e.preventDefault(), this.enableActiveFocus());
    }, this.handleDaySelect = (e, t) => {
      const s = Q(t, w(this.min), w(this.max)), a = !this.isDateDisabled(t);
      s && a ? (this.setValue(t), this.hide()) : this.setFocusedDay(t);
    }, this.handleMonthSelect = (e) => {
      this.setMonth(parseInt(e.target.value, 10));
    }, this.handleYearSelect = (e) => {
      this.setYear(parseInt(e.target.value, 10));
    }, this.handleInputChange = () => {
      const e = this.datePickerInput;
      es(e, ts);
      const t = this.dateAdapter.parse(e.value, Ie);
      (t || e.value === "") && this.setValue(t);
    }, this.processFocusedDayNode = (e) => {
      this.focusedDayNode = e, this.activeFocus && this.open && setTimeout(() => e.focus(), 0);
    };
  }
  connectedCallback() {
    this.createDateFormatters();
  }
  createDateFormatters() {
    this.dateFormatShort = new Intl.DateTimeFormat(this.localization.locale, { day: "numeric", month: "long" }), this.dateFormatLong = new Intl.DateTimeFormat(this.localization.locale, {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  }
  /**
   * Component event handling.
   */
  handleDocumentClick(e) {
    if (!this.open)
      return;
    e.composedPath().every((s) => s !== this.dialogWrapperNode && s !== this.datePickerButton) && this.hide(!1);
  }
  /**
   * Public methods API
   */
  /**
   * Sets focus on the date picker's input. Use this method instead of the global `focus()`.
   */
  async setFocus() {
    return this.datePickerInput.focus();
  }
  /**
   * Show the calendar modal, moving focus to the calendar inside.
   */
  async show() {
    this.open = !0, this.duetOpen.emit({
      component: "duet-date-picker"
    }), this.setFocusedDay(w(this.value) || /* @__PURE__ */ new Date()), clearTimeout(this.focusTimeoutId), this.focusTimeoutId = setTimeout(() => this.monthSelectNode.focus(), ge);
  }
  /**
   * Hide the calendar modal. Set `moveFocusToButton` to false to prevent focus
   * returning to the date picker's button. Default is true.
   */
  async hide(e = !0) {
    this.open = !1, this.duetClose.emit({
      component: "duet-date-picker"
    }), clearTimeout(this.focusTimeoutId), e && setTimeout(() => this.datePickerButton.focus(), ge + 200);
  }
  addDays(e) {
    this.setFocusedDay(Ne(this.focusedDay, e));
  }
  addMonths(e) {
    this.setMonth(this.focusedDay.getMonth() + e);
  }
  addYears(e) {
    this.setYear(this.focusedDay.getFullYear() + e);
  }
  startOfWeek() {
    this.setFocusedDay(Ye(this.focusedDay, this.firstDayOfWeek));
  }
  endOfWeek() {
    this.setFocusedDay(Oe(this.focusedDay, this.firstDayOfWeek));
  }
  setMonth(e) {
    const t = pe(Y(this.focusedDay), e), s = O(t), a = pe(this.focusedDay, e);
    this.setFocusedDay(R(a, t, s));
  }
  setYear(e) {
    const t = $e(Y(this.focusedDay), e), s = O(t), a = $e(this.focusedDay, e);
    this.setFocusedDay(R(a, t, s));
  }
  setFocusedDay(e) {
    this.focusedDay = R(e, w(this.min), w(this.max));
  }
  setValue(e) {
    this.value = Ae(e), this.duetChange.emit({
      component: "duet-date-picker",
      value: this.value,
      valueAsDate: e
    });
  }
  /**
   * render() function
   * Always the last one in the class.
   */
  render() {
    const e = w(this.value), t = e && this.dateAdapter.format(e), s = (e || this.focusedDay).getFullYear(), a = this.focusedDay.getMonth(), o = this.focusedDay.getFullYear(), i = w(this.min), n = w(this.max), r = i != null && i.getMonth() === a && i.getFullYear() === o, l = n != null && n.getMonth() === a && n.getFullYear() === o, u = i ? i.getFullYear() : s - 10, h = n ? n.getFullYear() : s + 10;
    return d(be, null, d("div", { class: "duet-date" }, d(Wt, { dateFormatter: this.dateFormatLong, value: this.value, valueAsDate: e, formattedValue: t, onInput: this.handleInputChange, onBlur: this.handleBlur, onFocus: this.handleFocus, onClick: this.toggleOpen, name: this.name, disabled: this.disabled, role: this.role, required: this.required, identifier: this.identifier, localization: this.localization, buttonRef: (c) => this.datePickerButton = c, inputRef: (c) => this.datePickerInput = c }), d("div", { class: {
      "duet-date__dialog": !0,
      "is-left": this.direction === "left",
      "is-active": this.open
    }, role: "dialog", "aria-modal": "true", "aria-hidden": this.open ? "false" : "true", "aria-labelledby": this.dialogLabelId, onTouchMove: this.handleTouchMove, onTouchStart: this.handleTouchStart, onTouchEnd: this.handleTouchEnd }, d("div", { class: "duet-date__dialog-content", onKeyDown: this.handleEscKey, ref: (c) => this.dialogWrapperNode = c }, d("div", { class: "duet-date__mobile", onFocusin: this.disableActiveFocus }, d("label", { class: "duet-date__mobile-heading" }, this.localization.calendarHeading), d("button", { class: "duet-date__close", ref: (c) => this.firstFocusableElement = c, onKeyDown: this.handleFirstFocusableKeydown, onClick: () => this.hide(), type: "button" }, d("svg", { "aria-hidden": "true", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" }, d("path", { d: "M0 0h24v24H0V0z", fill: "none" }), d("path", { d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" })), d("span", { class: "duet-date__vhidden" }, this.localization.closeLabel))), d("div", { class: "duet-date__header", onFocusin: this.disableActiveFocus }, d("div", null, d("h2", { id: this.dialogLabelId, class: "duet-date__vhidden", "aria-live": "polite", "aria-atomic": "true" }, this.localization.monthNames[a], " ", this.focusedDay.getFullYear()), d("label", { htmlFor: this.monthSelectId, class: "duet-date__vhidden" }, this.localization.monthSelectLabel), d("div", { class: "duet-date__select" }, d("select", { id: this.monthSelectId, class: "duet-date__select--month", ref: (c) => this.monthSelectNode = c, onChange: this.handleMonthSelect }, this.localization.monthNames.map((c, f) => d("option", { key: c, value: f, selected: f === a, disabled: !Q(new Date(o, f, 1), i ? Y(i) : null, n ? O(n) : null) }, c))), d("div", { class: "duet-date__select-label", "aria-hidden": "true" }, d("span", null, this.localization.monthNamesShort[a]), d("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" }, d("path", { d: "M8.12 9.29L12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7c-.39-.39-.39-1.02 0-1.41.39-.38 1.03-.39 1.42 0z" })))), d("label", { htmlFor: this.yearSelectId, class: "duet-date__vhidden" }, this.localization.yearSelectLabel), d("div", { class: "duet-date__select" }, d("select", { id: this.yearSelectId, class: "duet-date__select--year", onChange: this.handleYearSelect }, Vt(u, h).map((c) => d("option", { key: c, selected: c === o }, c))), d("div", { class: "duet-date__select-label", "aria-hidden": "true" }, d("span", null, this.focusedDay.getFullYear()), d("svg", { fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" }, d("path", { d: "M8.12 9.29L12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7c-.39-.39-.39-1.02 0-1.41.39-.38 1.03-.39 1.42 0z" }))))), d("div", { class: "duet-date__nav" }, d("button", { class: "duet-date__prev", onClick: this.handlePreviousMonthClick, disabled: r, type: "button" }, d("svg", { "aria-hidden": "true", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 24 24" }, d("path", { d: "M14.71 15.88L10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z" })), d("span", { class: "duet-date__vhidden" }, this.localization.prevMonthLabel)), d("button", { class: "duet-date__next", onClick: this.handleNextMonthClick, disabled: l, type: "button" }, d("svg", { "aria-hidden": "true", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 24 24" }, d("path", { d: "M9.29 15.88L13.17 12 9.29 8.12c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42z" })), d("span", { class: "duet-date__vhidden" }, this.localization.nextMonthLabel)))), d(Gt, { dateFormatter: this.dateFormatShort, selectedDate: e, focusedDate: this.focusedDay, onDateSelect: this.handleDaySelect, onKeyboardNavigation: this.handleKeyboardNavigation, labelledById: this.dialogLabelId, localization: this.localization, firstDayOfWeek: this.firstDayOfWeek, focusedDayRef: this.processFocusedDayNode, min: i, max: n, isDateDisabled: this.isDateDisabled })))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      localization: ["createDateFormatters"]
    };
  }
  static get style() {
    return Qt;
  }
}, as = /* @__PURE__ */ Lt(ss, [0, "duet-date-picker", { name: [1], identifier: [1], disabled: [516], role: [1], direction: [1], required: [4], value: [1537], min: [1], max: [1], firstDayOfWeek: [2, "first-day-of-week"], localization: [16], dateAdapter: [16], isDateDisabled: [16], activeFocus: [32], focusedDay: [32], open: [32] }, [[6, "click", "handleDocumentClick"]]]), os = (e) => {
  typeof customElements < "u" && [
    as
  ].forEach((t) => {
    customElements.get(t.is) || customElements.define(t.is, t, e);
  });
};
function I(e, t, s) {
  G(() => {
    if (e.current) {
      const a = e.current;
      if (s)
        return a.addEventListener(t, s), () => a.removeEventListener(t, s);
    }
    return () => {
    };
  }, [t, s, e]);
}
function is(e, t) {
  return (s) => {
    var i, n, r, l;
    t && t(s);
    const { height: a, top: o } = ((n = (i = e.current) == null ? void 0 : i.querySelector(".duet-date__dialog")) == null ? void 0 : n.getBoundingClientRect()) || {};
    a && o && a + o > window.innerHeight && ((l = (r = document.scrollingElement) == null ? void 0 : r.scrollBy) == null || l.call(r, 0, o + a - window.innerHeight + 40));
  };
}
const ns = ({
  onChange: e,
  onFocus: t,
  onBlur: s,
  onOpen: a,
  onClose: o,
  isDateDisabled: i,
  ...n
}) => {
  const r = He(null);
  return G(() => {
    os(window), r.current && (r.current.dateAdapter = Xe);
  }, []), G(() => {
    r.current && i !== void 0 && (r.current.isDateDisabled = i);
  }, [i]), I(r, "duetChange", e), I(r, "duetFocus", t), I(r, "duetBlur", s), I(r, "duetOpen", is(r, a)), I(r, "duetClose", o), /* @__PURE__ */ me(Be, { children: [
    /* @__PURE__ */ k("duet-date-picker", { ref: r, ...n }),
    /* @__PURE__ */ k(Ze, {})
  ] });
}, rs = ({
  name: e,
  label: t,
  onChange: s,
  onBlur: a,
  onClose: o,
  isDateDisabled: i,
  errorLabelProps: n,
  disabled: r,
  divider: l,
  hint: u,
  placeholder: h,
  ...c
}) => {
  const [f, p, g] = Pe(e), $ = !!(p.error && p.touched);
  return /* @__PURE__ */ me(Qe, { children: [
    /* @__PURE__ */ k(We, { htmlFor: e, id: `${e}.label`, children: t }),
    /* @__PURE__ */ k(Ve, { children: /* @__PURE__ */ k(
      Ue,
      {
        disabled: !!r,
        field: {
          ...f,
          onChange: (x) => {
            const Re = Ge(x.target.value ?? "", l);
            g.setValue(Re ?? "");
          },
          // Render the stored value in our DMY format
          value: Je(f.value ?? "") ?? ""
        },
        meta: p,
        divider: l,
        placeholder: h
      }
    ) }),
    /* @__PURE__ */ k(
      ns,
      {
        disabled: !!r,
        "aria-labelledby": `${e}.label`,
        ...$ ? { "aria-errormessage": (n == null ? void 0 : n.id) ?? `${e}.errorlabel` } : {},
        "aria-invalid": $,
        onChange: async (x) => {
          await g.setValue(x.detail.value, !0), s && s(x);
        },
        onBlur: (x) => {
          setTimeout(() => {
            f.onBlur(x), a && a(x);
          }, 0);
        },
        onClose: (x) => {
          setTimeout(() => {
            f.onBlur(x), o && o(x);
          }, 0);
        },
        isDateDisabled: i,
        value: f.value,
        name: e,
        ...c
      }
    ),
    $ && /* @__PURE__ */ k(Ke, { id: `${e}.errorlabel`, ...n, children: p.error }),
    u && /* @__PURE__ */ k(qe, { children: u })
  ] });
}, $s = je(rs);
export {
  ns as DatePicker,
  rs as FormikDatePicker,
  $s as default
};
